import React, { FunctionComponent } from 'react';
import CitationDetailNode from './CitationDetailNode';
import { Link } from 'react-router-dom';
import { Box, makeStyles, Slide, Theme } from '@material-ui/core';
import moment from 'moment';
import gray from '@material-ui/core/colors/grey';
import { Citation } from '../../../store/modules/citation/types';
import { getFullAddress, getPersonSimpleName } from '../../../utils/utils';
import { Address } from '../../../store/modules/application/types';

type CitationDetailNodeProps = {
    doShowDetail: boolean;
    citationData: Citation;
    className: string;
    address: Address | undefined;
};

const CitationDetail: FunctionComponent<CitationDetailNodeProps> = (props) => {
    const classes = makeStyles((theme: Theme) => ({
        header: {
            color: theme.palette.primary.light,
            fontWeight: 500,
        },
        anchorValue: {
            fontSize: 14,
            fontWeight: 450,
            color: gray[600],
        },
    }))();
    const { doShowDetail, className, citationData, address } = props;

    return (
        <aside>
            {!doShowDetail && <Box className={className}></Box>}
            <Slide in={doShowDetail} direction="right" mountOnEnter={true} unmountOnExit={true}>
                <Box className="detail-container detail-container-mobile">
                    <h3 className={classes.header}>DETAILS</h3>
                    <CitationDetailNode label="Licensee Type" value={citationData.person.type?.name} />
                    <CitationDetailNode
                        label="Licensee"
                        value={
                            <Link to={`/licensing/person/${citationData.person.id}/detail`}>
                                {getPersonSimpleName(citationData.person.name)}
                            </Link>
                        }
                    />
                    <CitationDetailNode label="Address" value={getFullAddress(address)} />
                    <CitationDetailNode label="Citation Date" value={moment(citationData.citationDate).format('L')} />
                    <CitationDetailNode label="Status" value={citationData.status} />
                </Box>
            </Slide>
        </aside>
    );
};

export default CitationDetail;
